import React, {useEffect} from 'react'
import { Button } from '../../../components/button'
import { Link } from "react-router-dom";
import ApiKeyForm from '../../../components/forms/apikey-form';
import { useSelector, useDispatch } from 'react-redux'
import { clearApiKeyData } from '../../../slices/apikeys';


const ApiKeyCreate = () => {

    const apiKeyData = useSelector((state) => state.apikeys.apiKeyData)
    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            // clean up the form on unmount
            dispatch(clearApiKeyData())
        }
    }, [])

    function copyToClipboard(id, bid) {
        var input = document.getElementById(id);
        input.select();
        input.setSelectionRange(0, 99999); // For mobile devices
        document.execCommand("copy");
        input.blur();
        var button = document.getElementById(bid);
        button.textContent = gettext("Copied!");
        setTimeout(function() {
          button.textContent = gettext("Copy");
        }, 1000);
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row clamped">
                    <div className="col px-0 settings-header flex-wrap">
                        <h1 className="title">{gettext("New API Key")}</h1>
                        { !apiKeyData &&
                            <Link to={"/settings/apikeys"}><Button variant={"secondary"} size={"sm"}>{gettext('Cancel')}</Button></Link>
                        }
                    </div>
                </div>
            </div>
            { apiKeyData ?
                <>
                    <div className="contentarea clamped">
                        <div className="container-fluid detail">
                            <div className="row">
                                <div className="col-12 mb-4">
                                    <p><strong>{gettext('These are the new API keys')}</strong></p>
                                    <p><strong>{gettext('Please copy them to safe storage, they will only be available this once.')}</strong></p>
                                </div>
                            </div>
                            <div className="row align-items-end">
                                <div className="col-9 mb-4">
                                    <label>{gettext('Public Key')}</label>
                                    <input id="public-key" type="text" value={apiKeyData.public} className="form-control" />
                                </div>
                                <div className="col-3 mb-4">
                                    <button id="public-copy" className="btn btn-secondary mb-1 w-100" onClick={() => copyToClipboard("public-key", "public-copy")}>{gettext("Copy")}</button>
                                </div>
                            </div>
                            <div className="row align-items-end">
                                <div className="col-9 mb-4">
                                    <label>{gettext('Private Key')}</label>
                                    <input id="private-key" type="text" value={apiKeyData.private} className="form-control" />
                                </div>
                                <div className="col-3 mb-4">
                                    <button id="private-copy" className="btn btn-secondary mb-1 w-100" onClick={() => copyToClipboard("private-key", "private-copy")}>{gettext("Copy")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="clamped text-end mt-3">
                        <Link to={"/settings/apikeys/"}><Button>{gettext('Close')}</Button></Link>
                    </div>
                </>
            :
            <ApiKeyForm />
            }
        </>
    )
}

export default ApiKeyCreate